import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var CornerUpLeft = createReactComponent("CornerUpLeft", ["svg", defaultAttributes, [["polyline", {
  points: "9 14 4 9 9 4",
  key: "17q6t5"
}], ["path", {
  d: "M20 20v-7a4 4 0 00-4-4H4",
  key: "kxfyy5"
}]]]);
export default CornerUpLeft;